<p-toast> </p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"> </p-confirmDialog>
<section class="toggle-form user-profile-slider"
[ngClass]="{ active: isUserProfileSliderOpen }">

  <div class="formwrap">
        <div class="Header">
          <h2>
            <b>{{sliderHeaderText}}</b>
          </h2>
          <p-button
            styleClass="p-button-text"
            id="userProfileCloseBtn"
            type="button"
            label="Close"
            (onClick)="confirmClose()"
          ></p-button>
        </div>
      <form [formGroup]="userProfileForm">
        <div *ngIf="errorMessages.length > 0">
          <p-messages severity="error">
            <ng-template pTemplate>
              <span class="p-message-icon pi pi-times-circle"></span>
              <span class="p-ml-2"
                >Please correct the following errors to create update the user profile information.</span
              >
              <ul>
                <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
              </ul>
            </ng-template>
          </p-messages>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown
              label="Primary eQMS Scope"
              [options]="eQMSScopesForPrimaryScopeList"
              [editable]="false"
              formControlName="PrimaryeQMSScope"
              id="userProfilePrimaryeQMSScope"
              [showClear]="true"
              [required]="iseQMSScopeRequired"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.PrimaryeQMSScope }"
            >
            </bpt-dropdown>
          </div>
          <div class="field">
            <bpt-dropdown
              label="Other eQMS Scope(s)"
              [options]="eQMSScopeList"
              [editable]="false"
              formControlName="OthereQMSScopes"
              id="userProfileOthereQMSScopes"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [multiSelect]="true"
            >
            </bpt-dropdown>
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown
              label="Manager"
              [options]="usersList"
              [editable]="false"
              formControlName="manager"
              id="manager"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueFieldForPuid"
              [labelField]="labelField"
            >
            </bpt-dropdown>
          </div>
          <div class="field field-required">
            <bpt-dropdown
              label="Security / Permission "
              [options]="securityPermissions"
              [editable]="false"
              formControlName="securityPermissions"
              id="userSecurityPermissions"
              [showClear]="true"
              [required]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [multiSelect]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.securityPermissions }"
            >
            </bpt-dropdown>
          </div>
        </div>
        <div class="fields-row">
            <div class="field1 field-required">
                <bpt-datetime
                  id="userHireDate"
                  label="Hire Date "
                  formControlName="hireDate"
                  [required]="true"
                  [ngClass]="{ 'error-highlight': mandatoryFields.hireDate }"
                ></bpt-datetime>
              </div>
              <div class="field2" >
                <bpt-datetime
                  id="userTerminationDate"
                  label="Termination Date"
                  formControlName="terminationDate"
                  (ngModelChange)="onTerminationDateChange()"
                ></bpt-datetime>
                <i
                class="fa fa-info-circle info-icon-color infoIcon"
                aria-hidden="true"
                pTooltip="{{infoForTerminationDate}}"
              ></i>
            </div>
          </div>

        <p-button
          label="Save"
          type="submit"
          id="userProfileSaveBtn"
          class="align-right"
          (onClick)="UpdateUserProfile()"
        >
        </p-button>
      </form>
  </div>
</section>
